export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";